package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun WindWalkMetadata() {
    SpellMetadata(
        spellIndex = "wind-walk",
        castingTime = "1 minute",
        range = "30 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC, SpellComponent.MATERIAL),
        material = "Fire and holy water.",
        duration = "8 hours",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
